module.exports = __webpack_public_path__ + "img/service_icon_1.2513f9f2.svg";